var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrviCiklus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.875 18.125C16.875 18.4705 16.5952 18.75 16.25 18.75H5.625C3.21259 18.75 1.25 16.7871 1.25 14.375V3.75C1.25 3.40454 1.52985 3.125 1.875 3.125C2.22015 3.125 2.5 3.40454 2.5 3.75V14.375C2.5 16.098 3.90198 17.5 5.625 17.5H16.25C16.5952 17.5 16.875 17.7795 16.875 18.125ZM18.75 3.125V14.375C18.75 15.4089 17.9089 16.25 16.875 16.25H5.625C4.59106 16.25 3.75 15.4089 3.75 14.375V3.125C3.75 2.09106 4.59106 1.25 5.625 1.25H16.875C17.9089 1.25 18.75 2.09106 18.75 3.125ZM12.5 5.625C12.5 5.42419 12.4036 5.2356 12.2403 5.1178C12.0767 5.00061 11.8677 4.96765 11.6772 5.03235L9.80225 5.65735C9.47479 5.76599 9.29779 6.12 9.40704 6.44775C9.51599 6.7749 9.86969 6.95251 10.1978 6.84265L11.25 6.49231V11.875C11.25 12.2205 11.5298 12.5 11.875 12.5C12.2202 12.5 12.5 12.2205 12.5 11.875V5.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrviCiklus);
export default __webpack_public_path__ + "static/media/prvi-ciklus.3c890175d65c0f570552c5b4aa5ac021.svg";
export { ForwardRef as ReactComponent };